import { useCart } from "./../../context/cartContext";
import { IconAddressBook, IconCash, IconChecklist, IconMap2, IconTruckDelivery, IconWallet, IconX } from "@tabler/icons-react";
import { splitNumber } from "../../features/splitNumber/splitNumber";
import { useEffect, useState } from "react";
import { GetCarts } from "../../services/panel/cart/getCart";
import useGetData from "../../hook/getData";
// @ts-ignore
import Cookies from "js-cookie";
import { useMutation } from "@tanstack/react-query";
import { toastOptions } from "../../features/toast/toast";
import { toast } from "react-toastify";
import { GetProvinces } from "../../services/panel/address/getProvinces";
import Select from 'react-select';
import { GetCities } from "../../services/panel/address/getCities";
import { useForm } from "react-hook-form";
import { onError } from "../../features/error/error";
import { SendAddress } from "../../services/panel/address/sendAddress";
import { GetAddress } from "../../services/panel/address/getAddress";
import { SendPayment } from "../../services/panel/payment/sendPayment";
import { GetProfile } from "../../services/panel/profile/getProfile";
import { GetSend } from "../../services/panel/send/getSend";
// @ts-ignore
import moment from "jalali-moment";
moment.locale('fa');

type DateOption = {
    label: string;
    value: string;
};

type HolidayCache = {
    [key: string]: boolean;
};

let holidayCache: HolidayCache = {};

const isHoliday = async (jYear: number, jMonth: number, jDay: number): Promise<boolean> => {
    const key = `${jYear}-${String(jMonth).padStart(2, '0')}-${String(jDay).padStart(2, '0')}`;
    if (holidayCache[key] !== undefined) {
        return holidayCache[key];
    }
    try {
        const res = await fetch(`https://holidayapi.ir/jalali/${jYear}/${jMonth}/${jDay}`);
        const data = await res.json();
        const result = data.isHoliday || false;
        holidayCache[key] = result;
        return result;
    } catch {
        holidayCache[key] = false;
        return false;
    }
};

const getNextWorkingDays = async (count = 4): Promise<DateOption[]> => {
    const result: DateOption[] = [];
    let date = moment().startOf('day');
    while (result.length < count) {
        const jYear = date.jYear();
        const jMonth = date.jMonth() + 1;
        const jDay = date.jDate();
        const dayOfWeek = date.day();
        const isWeekend = dayOfWeek === 5;
        if (!isWeekend) {
            const holiday = await isHoliday(jYear, jMonth, jDay);
            if (!holiday) {
                const label = date.format('jD jMMMM dddd');
                const value = date.format('jYYYY-jMM-jDD');
                result.push({ label, value });
            }
        }
        date = date.add(1, 'day');
    }
    return result;
};

const ShopModal = () => {
    const { cart } = useCart();
    const { data: carts, isLoading } = useGetData(['carts'], GetCarts);
    const { data: provinces } = useGetData(['provinces'], GetProvinces);
    const { data: address, refetch: adrefe } = useGetData(['address'], GetAddress);
    const { data: profile } = useGetData(['profile'], GetProfile);
    const { data: sends } = useGetData(['Send'], GetSend);
    const [cities, setCities] = useState([]);
    const { register, handleSubmit, reset }: any = useForm<any>();
    const provinceOptions = provinces?.map((p: { id: any; name: any; }) => ({
        value: p.id,
        label: p.name
    }));
    const totalPrice = cart.reduce((sum, item) => sum + item.item_price * item.qty, 0)

    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('pages-header')?.classList.remove('d-none');
    }, []);

    const cityMutation = useMutation({
        mutationFn: GetCities,
        onSuccess: (data) => {
            let cityOptions = data?.map((p: { id: any; name: any; }) => ({
                value: p.id,
                label: p.name
            }));
            setCities(cityOptions);
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const [value, setValue] = useState(null);
    const [Cityvalue, setCityValue] = useState(null);
    const [selectedSend, setSelectedSend] = useState<string | null>(null);
    const [priceDeliver, setPriceDeliver] = useState<string | any>('0');
    const onChange = (selectedOption: any) => {
        setValue(selectedOption?.value);
        cityMutation.mutate(selectedOption?.value);
        setCityValue(null);
        setSelectedSend(null);
    };

    const selectDeliver = (id: any, cost: any) => {
        setSelectedSend(id)
        setPriceDeliver(cost)
    }

    const onChangeCity = (selectedOption: any) => {
        setCityValue(selectedOption?.value);
        setSelectedSend(null);
    };

    const addreeMutation = useMutation({
        mutationFn: SendAddress,
        onSuccess: () => {
            adrefe();
            document.getElementById('close-addrees')?.click();
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const paymentMutation = useMutation({
        mutationFn: SendPayment,
        onSuccess: (data) => {
            window.open(data.paymentLink, '_self');
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            toast.error(errors, toastOptions);
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const onSubmit = (data: any) => {
        data.province_id = value;
        data.city_id = Cityvalue;
        data.im_receiver = isSelfReceiver ? 1 : 0;
        addreeMutation.mutate(data);
    };

    const [selectCity, setSelect] = useState('');
    const [isSelfReceiver, setIsSelfReceiver] = useState(false);
    const [deliveryDates, setDeliveryDates] = useState<DateOption[]>([]);
    const [selectedDate, setSelectedDate] = useState<string | null>(null);

    useEffect(() => {
        reset({
            name: profile?.name || '',
            lastName: profile?.lastName || '',
            email: profile?.email || '',
            national_code: profile?.national_code,
            gender: profile?.gender,
            cellphone: profile?.cellphone,
            nationalCode: profile?.national_code,
        });
    }, [profile?.cellphone, profile?.email, profile?.gender, profile?.lastName, profile?.name, profile?.national_code, reset]);

    const [paymentType, setPaymentType] = useState<'online' | 'wallet' | ''>('');

    useEffect(() => {
        const fetchDates = async () => {
            const validDates: any = await getNextWorkingDays();
            setDeliveryDates(validDates);
        };
        fetchDates();
    }, []);

    const sendToPay = () => {
        if (!selectedDate) {
            toast.error("لطفا یک تاریخ ارسال انتخاب کنید", toastOptions);
            return;
        }
        if (!selectCity) {
            toast.error("لطفا یک آدرس انتخاب کنید", toastOptions);
            return;
        }
        if (!selectedSend) {
            toast.error("لطفا یک روش ارسال انتخاب کنید", toastOptions);
            return;
        }
        if (!paymentType) {
            toast.error("لطفا روش پرداخت را انتخاب کنید");
            return;
        }
        const data = {
            address_id: Number(selectCity),
            delivery_date: selectedDate,
            shipping_method_id: Number(selectedSend),
            payment_type: paymentType,
        };
        paymentMutation.mutate(data);
    };

    const selectedAddress = address?.addresses?.find((addr: any) => addr.id === selectCity);
    const isTabrizOrTehran = selectedAddress?.city_id === 174 || selectedAddress?.city_id === 304;
    const filteredSends = isTabrizOrTehran
        ? sends?.filter((item: any) => item.name === 'حضوری' || item.name === 'پست')
        : sends?.filter((item: any) => item.name !== 'حضوری' && item.name !== 'پست');

    const priceDeliverNumber = Number(priceDeliver.replace(/[,٬]/g, ''));

    const total = Cookies.get('agent_token')
        ? (carts?.cartTotalAmount || 0) + priceDeliverNumber
        : totalPrice + priceDeliverNumber;

    const totalFormatted = splitNumber(total);
    return (
        <>
            {isLoading ? (
                <div className="container h-100 mt-5">
                    <div className="row h-100 justify-content-center py-5 align-items-center">
                        <div className="col-md-6 text-center">
                            <img alt="logo" className="acband-price-icon animate-logo" src={require('../../assets/media/logo/final.png')} />
                            <p className="fw-bold mt-3">
                                در حال بارگزاری..
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <section className="bg-white container">
                    <div className="row gy-5 py-5">
                        <div className="col-md-8">
                            <div className="card card-body shadow border-0">
                                <div>
                                    <IconAddressBook className="me-2" />
                                    انتخاب آدرس
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ul className="list-group px-0">
                                            {address?.addresses?.map((address: any) => (
                                                <li key={address.id} className="list-group-item px-0">
                                                    <div onClick={() => { setSelect(address.id); setSelectedSend(null); }}
                                                        className={`d-md-flex align-items-center justify-content-between border border-1 py-3 px-md-3 px-3 rounded rounded-3 p-2 ${selectCity === address.id ? 'select-box' : ''}`}>
                                                        <input type="radio"
                                                            checked={selectCity === address.id}
                                                            onChange={() => { setSelect(address.id); setSelectedSend(null); }}
                                                            name="address"
                                                            value={address.id}
                                                            className="form-check-input d-md-none d-inline-block border-2 border-black" />
                                                        <div className="d-flex align-items-center">
                                                            <IconMap2 className="d-md-inline d-none" />
                                                            <div className="ms-3">
                                                                <p className="mb-2">
                                                                    {address.address}
                                                                </p>
                                                                <ul className="breadcrumb">
                                                                    <li className="breadcrumb-item text-muted font-medium">
                                                                        عنوان : {address.title}
                                                                    </li>
                                                                    <li className="breadcrumb-item text-muted font-medium">
                                                                        شماره تماس : {address.cellphone}
                                                                    </li>
                                                                    <li className="breadcrumb-item d-md-inline d-none text-muted font-medium">
                                                                        کد پستی : {address.postal_code}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <input type="radio"
                                                            checked={selectCity === address.id}
                                                            onChange={() => { setSelect(address.id); setSelectedSend(null); }}
                                                            name="address"
                                                            value={address.id}
                                                            className="form-check-input d-md-inline-block d-none border-2 border-black" />
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button data-bs-toggle="modal" data-bs-target="#address-modal" className="btn btn-outline-primary mt-2">
                                            افزودن آدرس
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card card-body shadow border-0 mt-4">
                                <div>
                                    <IconTruckDelivery className="me-2" />
                                    شیوه ارسال
                                </div>
                                <div className="row g-3 mt-2">
                                    {filteredSends?.map((item: any) => (
                                        <div key={item.id} className="col-md-6 col-12 ">
                                            <div
                                                onClick={() => selectDeliver(item.id, item.cost)}
                                                className={`border rounded-3 p-3 d-flex align-items-center justify-content-between cursor-pointer ${selectedSend === item.id ? "select-box" : "border-gray"}`}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    <img src={item.icon} alt="" style={{ width: '40px', height: '40px' }} className="rounded rounded-circle me-3" />
                                                    <span>{item.name}</span>
                                                </div>
                                                <div>
                                                    {splitNumber(item.cost)}
                                                    <span className="text-muted ms-2 font-medium-lg">تومان</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="card card-body shadow border-0 mt-4">
                                <div className="mb-3">
                                    <IconChecklist className="me-2" />
                                    انتخاب زمان ارسال
                                </div>
                                <div className="row g-3">
                                    {deliveryDates.map((date: any) => (
                                        <div key={date.value} className="col-md-3 col-6">
                                            <div
                                                onClick={() => setSelectedDate(date.value)}
                                                className={`border rounded-3 p-3 text-center cursor-pointer ${selectedDate === date.value ? "select-box" : "border-gray"}`}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <span className="font-medium-lg">{date.label}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card card-body border-0 shadow position-sticky" style={{ top: '170px' }}>
                                <div className="d-flex justify-content-center">
                                    <img alt="logo" className="acband-price-icon" src={require('../../assets/media/logo/final.png')} />
                                </div>
                                <ul className="list-group mt-3">
                                    <li className="list-group-item">
                                        <div className="d-flex justify-content-between">
                                            <span>قیمت :</span>
                                            <span className="text-split fw-bold">
                                                {totalFormatted}
                                                <span className="ms-2">تومان</span>
                                            </span>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="d-flex justify-content-between">
                                            <span>نحوه ارسال :</span>
                                            <span className="text-split">
                                                {selectedSend ? filteredSends?.find((item: any) => item.id === selectedSend)?.name || 'ارسال آکبند' : 'ارسال آکبند'}
                                            </span>
                                        </div>
                                    </li>
                                    <li className="list-group-item">
                                        <div className="d-flex justify-content-between">
                                            <span>گارانتی :</span>
                                            <span className="text-split">دارای گارانتی</span>
                                        </div>
                                    </li>
                                </ul>
                                <div className="card card-body mt-3">
                                    <h6 className="text-site font-medium-lg">
                                        <IconChecklist />
                                        بیمه به کالا افزوده شده
                                    </h6>
                                    <p className="font-medium line-25 mb-0">
                                        با توجه به بالا بودن ارزش کالای انتخاب شده، بیمه تجهیزات دیجیتال - بیمه سامان برای شما به مبلغ {splitNumber(145122)} تومان فعال شد.
                                    </p>
                                </div>
                                <div className="mt-3 row">
                                    <div className="col-6 text-center">
                                        <div className={`card card-body ${paymentType === 'online' ? 'select-box' : ''}`} onClick={() => setPaymentType('online')}>
                                            <input
                                                type="radio"
                                                id="pay_online"
                                                name="payment_type"
                                                value="online"
                                                className="form-check-input me-2"
                                                checked={paymentType === 'online'}
                                                onChange={() => setPaymentType('online')}
                                            />
                                            <div style={{ marginTop: '-20px' }}>
                                                <p className="mb-2">
                                                    <IconCash />
                                                </p>
                                                <label htmlFor="pay_online" className="form-check-label">درگاه پرداخت </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 text-center">
                                        <div className={`card card-body ${paymentType === 'wallet' ? 'select-box' : ''}`} onClick={() => setPaymentType('wallet')}>
                                            <input
                                                type="radio"
                                                id="pay_wallet"
                                                name="payment_type"
                                                value="wallet"
                                                className="form-check-input me-2"
                                                checked={paymentType === 'wallet'}
                                                onChange={() => setPaymentType('wallet')}
                                            />
                                            <div style={{ marginTop: '-20px' }}>
                                                <p className="mb-2">
                                                    <IconWallet />
                                                </p>
                                                <label htmlFor="pay_wallet" className="form-check-label">کیف پول</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {Cookies.get('agent_token') ? (
                                    <button onClick={sendToPay} className="btn btn-primary mt-4">
                                        ثبت سفارش
                                    </button>
                                ) : (
                                    <button data-bs-toggle="modal" data-bs-target="#agent" className="btn btn-primary mt-4">
                                        ثبت سفارش
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="address-modal">
                        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
                            <div className="modal-content p-3">
                                <div className="modal-header justify-content-between">
                                    <h5 className="mb-0 fw-bold text-site">افزودن آدرس</h5>
                                    <IconX data-bs-dismiss="modal" />
                                </div>
                                <div className="modal-body">
                                    <h6 className="mt-2 mb-1">مشخصات خود را وارد نمایید</h6>
                                    <form onSubmit={handleSubmit(onSubmit, onError)}>
                                        <div className="row mb-3 gy-3 mt-1">
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="نام"
                                                        className="form-control"
                                                        {...register("name", { required: false })}
                                                    />
                                                    <label className="form-label">نام</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="نام خانوادگی"
                                                        className="form-control"
                                                        {...register("lastName", { required: false })}
                                                    />
                                                    <label className="form-label">نام خانوادگی</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="tel"
                                                        placeholder="شماره موبایل"
                                                        className="form-control"
                                                        {...register("cellphone", { required: false })}
                                                    />
                                                    <label className="form-label">شماره موبایل</label>
                                                </fieldset>
                                            </div>
                                            <div className="col-md-6">
                                                <fieldset className="form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="کدملی"
                                                        className="form-control"
                                                        {...register("nationalCode", { required: false })}
                                                    />
                                                    <label className="form-label">کدملی</label>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="row align-items-center">
                                            <h6 className="mt-2 mb-3">جزئیات آدرس را وارد کنید</h6>
                                            <div className="col-md-12">
                                                <div className="row align-items-center gy-4">
                                                    <div className="col-md-6">
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles) => ({
                                                                    ...baseStyles,
                                                                    height: 52,
                                                                    minHeight: 52,
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 99999,
                                                                }),
                                                            }}
                                                            options={provinceOptions}
                                                            onChange={onChange}
                                                            value={provinceOptions?.find((opt: { value: any; }) => opt.value === value)}
                                                            classNamePrefix="select border"
                                                            placeholder="انتخاب استان"
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles) => ({
                                                                    ...baseStyles,
                                                                    height: 52,
                                                                    minHeight: 52,
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                }),
                                                            }}
                                                            options={cities}
                                                            onChange={onChangeCity}
                                                            value={cities?.find((opt: { value: any; }) => opt.value === Cityvalue)}
                                                            classNamePrefix="select border"
                                                            placeholder="انتخاب شهر"
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input type="text" placeholder="عنوان" className="form-control"
                                                                {...register('title', { required: 'فیلد عنوان الزامی است' })}
                                                            />
                                                            <label className="form-label">عنوان</label>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input type="text" placeholder="آدرس" className="form-control"
                                                                {...register('address', { required: 'فیلد آدرس الزامی است' })}
                                                            />
                                                            <label className="form-label">آدرس</label>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <fieldset className="form-floating">
                                                            <input type="tel" placeholder="کدپستی" className="form-control"
                                                                {...register('postal_code', { required: 'فیلد کد پستی الزامی است' })}
                                                            />
                                                            <label className="form-label">کدپستی</label>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                <hr />
                                                <h6 className="mt-3 mb-2">مشخصات گیرنده را وارد نمایید</h6>
                                                <fieldset className="form-check mt-3">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isSelfReceiver}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setIsSelfReceiver(checked);
                                                            if (checked && profile) {
                                                                reset((prev: any) => ({
                                                                    ...prev,
                                                                    receiver_first_name: profile?.name || '',
                                                                    receiver_last_name: profile?.lastName || '',
                                                                    receiver_cellphone: profile?.cellphone || '',
                                                                    receiver_national_code: profile?.national_code || ''
                                                                }));
                                                            } else {
                                                                reset((prev: any) => ({
                                                                    ...prev,
                                                                    receiver_first_name: '',
                                                                    receiver_last_name: '',
                                                                    receiver_cellphone: '',
                                                                    receiver_national_code: ''
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    <label className="form-check-label">گیرنده خودم هستم</label>
                                                </fieldset>
                                                <div className="row mb-3 gy-3 mt-2">
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input
                                                                type="text"
                                                                placeholder="نام گیرنده"
                                                                className="form-control"
                                                                {...register("receiver_first_name", { required: 'نام گیرنده الزامی است' })}
                                                            />
                                                            <label className="form-label">نام گیرنده</label>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input
                                                                type="text"
                                                                placeholder="نام خانوادگی گیرنده"
                                                                className="form-control"
                                                                {...register("receiver_last_name", { required: 'نام خانوادگی گیرنده الزامی است' })}
                                                            />
                                                            <label className="form-label">نام خانوادگی گیرنده</label>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input
                                                                type="tel"
                                                                placeholder="شماره موبایل"
                                                                className="form-control"
                                                                {...register("receiver_cellphone", { required: 'شماره موبایل گیرنده الزامی است' })}
                                                            />
                                                            <label className="form-label">شماره موبایل</label>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <fieldset className="form-floating">
                                                            <input
                                                                type="text"
                                                                placeholder="کدملی گیرنده"
                                                                className="form-control"
                                                                {...register("receiver_national_code", { required: 'کدملی گیرنده الزامی است' })}
                                                            />
                                                            <label className="form-label">کدملی گیرنده</label>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                <button id="close-addrees" data-bs-dismiss="modal" type="button" className="d-none"></button>
                                                <button disabled={addreeMutation.isPending} className="btn py-3 w-100 btn-outline-primary mt-4">
                                                    افزودن آدرس
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default ShopModal;